// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InfoIcon-module__wrapper{cursor:pointer;vertical-align:text-bottom}", "",{"version":3,"sources":["webpack://src/components/lib/InfoIcon/InfoIcon.module.scss"],"names":[],"mappings":"AAAA,0BACE,cAAA,CACA,0BAAA","sourcesContent":[".wrapper {\n  cursor: pointer;\n  vertical-align: text-bottom;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "InfoIcon-module__wrapper"
};
export default ___CSS_LOADER_EXPORT___;
